import BasicInfo from "../../../components/basic-info/BasicInfo";
import { TextArea } from "../../../components/basic-info/TextArea";

interface IGroupInfo {
  data: IWorkExperiences;
}

interface IWorkExperiences {
  title: string;
  company: string;
  endDate: string;
  startDate: string;
  description: string;
}

export default function GroupWorkExp({
  data: { company, title, description, startDate, endDate },
}: IGroupInfo) {
  return (
    <div className="section">
      <div className="more-profile-info">
        <h4>Work Experience</h4>

        <BasicInfo title="Organization" data={company} />
        <BasicInfo title="Job Role" data={title} />
        <BasicInfo title="Start Date" data={startDate} />
        <BasicInfo title="End Date" data={endDate} />
        <TextArea lable="Role Description" value={description} />
      </div>
    </div>
  );
}
